import toast from "react-hot-toast"
import { apiConnector } from "../apiConnector"
import { apiClient } from "../apiClient"
import { setusers } from '../../slices/users'
import { profile, Manager_Profile } from '../oprations/Auth'

// Helper to get role
const getRole = () => {
    const user = localStorage.getItem('user')
    const userData = user ? JSON.parse(user) : null
    return userData?.role
}

/* ============ Common For Both Organization And Manager ======= */
export function Create_User(formData) {
    console.log("formdata...", formData)
    const token = localStorage.getItem('token')
    const role = getRole();
    const url = role === "Organization" ? apiClient.CREATE_USER : apiClient.CREATE_USER_MNG;
    console.log("url", url);
    return async (dispatch) => {
        try {
            const response = await apiConnector("POST", url, formData, {
                Authorization: `Bearer ${token}`
            })
            console.log("url", url);
            console.log("response url...", response)
            if (!response.data.success) {
                throw new Error(response.data.message)
            }
            toast.success(response.data.message || "User created successfully")
            await dispatch(Get_Managers_User())
            getRole() === "Organization" ? await dispatch(profile(token)) : await dispatch(Manager_Profile(token))
            return response
        } catch (error) {
            const message = error.response?.data?.message || error?.message
            console.log("Error In Create_User:", message)
            toast.error(message)
            return error?.response
        }
    }
}
export function Get_Managers_User() {
    const token = localStorage.getItem('token')
    const role = getRole()
    const url = role === "Organization" ? apiClient.GET_ALL_USERS : apiClient.GET_USER

    console.log("Get_Managers_User | Role:", role, "| URL:", url)

    return async (dispatch) => {
        try {
            const response = await apiConnector("GET", url, null, {
                Authorization: `Bearer ${token}`
            })
            if (!response.data.success) {
                throw new Error(response.data.message)
            }
            dispatch(setusers(response.data.data))
        } catch (error) {
            console.log("Error In Get_Managers_User:", error.message)
            toast.error(error.message)
        }
    }
}
export function Unenroll_User(_id, deviceId = null,enrollmentId = null) {
    const token = localStorage.getItem('token')
    const role = getRole()
    return async (dispatch) => {
        try {
            // const response = await apiConnector("GET", apiClient.DELETE_USER_FROM_DEVICE + `/${_id}`, null, {
            //     Authorization: `Bearer ${token}`
            // }, { deviceId: deviceId })
            console.log("EnrollIdAndDeviceId:",deviceId,enrollmentId)
            const url = role === "Organization"
                ? apiClient.UNENROLL_USER_FROM_DEVICES_ORG + `/${_id}`
                : apiClient.UNENROLL_USER_FROM_DEVICE + `/${_id}`

            console.log("unenroll_User | Role:", role, "| URL:", url)

            const response = await apiConnector("GET", url, null, {
                Authorization: `Bearer ${token}`
            }, { deviceId: deviceId,FingerId:enrollmentId })
            if (!response.data.success) {
                throw new Error(response.data.message)
            }
            toast.success(response.data.message)
            await dispatch(Get_Managers_User())
            return response
        } catch (error) {
            const message = error.response?.data?.message || error.message
            console.log("Error In Unenroll_User:", message)
            toast.error(message)
            return error.response
        }
    }
}
export function Delete_User(userId) {
    const token = localStorage.getItem('token')
    const role = getRole()
    return async (dispatch) => {
        try {
            // Organization uses its own delete endpoint, Manager uses user delete endpoint
            const url = role === "Organization"
                ? apiClient.DELETE_USER_ORG + `/${userId}`
                : apiClient.DELETE_USER + `/${userId}`

            console.log("Delete_User | Role:", role, "| URL:", url)

            const response = await apiConnector("DELETE", url, null, {
                Authorization: `Bearer ${token}`
            })
            if (!response.data.success) {
                throw new Error(response.data.message)
            }
            toast.success(response.data.message)
            await dispatch(Get_Managers_User())
            role === "Organization" ? await dispatch(profile(token)) : await dispatch(Manager_Profile(token))
            return response
        } catch (error) {
            const message = error.response?.data?.message || error.message
            console.log("Error In Delete_User:", message)
            toast.error(message)
            return error.response
        }
    }
}
export function Enrolled_User(_id, deviceId) {
    console.log("Enroll_User_Org called with _id:", _id, "and deviceId:", deviceId)
    const token = localStorage.getItem('token')
    const role = getRole()
    console.log("token", token)
    return async (dispatch) => {
        try {
            const url = role === "Organization"
                ? apiClient.ENROLLED_USER_ORG + `/${_id}/${deviceId}`
                : apiClient.ENROLLED_USER_MNG + `/${_id}/${deviceId}`

            console.log("Enrolled_User | Role:", role, "| URL:", url)
            const response = await apiConnector("POST", url, null, {
                Authorization: `Bearer ${token}`
            })
            console.log("Enroll_User_Org API Response:", response)
            if (!response.data.success) {
                throw new Error(response.data.message)
            }
            return response
        } catch (error) {
            const message = error.response?.data?.message || error?.message
            console.log("Error In Enroll_User:", message)
            toast.error(message)
            return error?.response
        }
    }
}
export function Import_User_Template(formData) {
    console.log("Import_User_Org called:", formData,)
    const token = localStorage.getItem('token')
    const role = getRole()
    console.log("token", token)
    return async (dispatch) => {
        try {
            const url = role === "Organization"
                ? apiClient.IMPORT_USER_ORG + `/${formData.userId}/${formData.deviceId}/${formData.thumbId}`
                : apiClient.IMPORT_USER_MNG + `/${formData.userId}/${formData.deviceId}/${formData.thumbId}`

            console.log("Enrolled_User | Role:", role, "| URL:", url)
            const response = await apiConnector("POST", url, null, {
                Authorization: `Bearer ${token}`
            })
            console.log("Enroll_User_Org API Response:", response)
            if (!response.data.success) {
                throw new Error(response.data.message)
            }
            dispatch(Get_Managers_User())
            return response
        } catch (error) {
            const message = error.response?.data?.message || error?.message
            console.log("Error In Enroll_User:", message)
            toast.error(message)
            return error?.response
        }
    }
}
export function Export_User_Template(formData) {
    console.log("Export_User_Org called:", formData,)
    const token = localStorage.getItem('token')
    const role = getRole()
    console.log("token", token)
    return async (dispatch) => {
        try {
            const url = role === "Organization"
                ? apiClient.EXPORT_USER_ORG
                : apiClient.EXPORT_USER_MNG

            console.log("Export_User | Role:", role, "| URL:", url)
            const response = await apiConnector("POST", url, formData, {
                Authorization: `Bearer ${token}`
            })
            console.log("Enroll_User_Org API Response:", response)
            if (!response.data.success) {
                throw new Error(response.data.message)
            }
            dispatch(Get_Managers_User())
            return response
        } catch (error) {
            const message = error.response?.data?.message || error?.message
            console.log("Error In Enroll_User:", message)
            toast.error(message)
            return error?.response
        }
    }
}
export function Delete_All_User(userIds) {
    console.log("userIds", userIds)
    const token = localStorage.getItem('token')
    const role = getRole()
    return async (dispatch) => {
        try {
            // Organization uses its own delete endpoint, Manager uses user delete endpoint
            const url = role === "Organization"
                ? apiClient.DELETE_ALL_USERS_ORG
                : apiClient.DELETE_ALL_USERS_MNG

            console.log("Delete_All_User | Role:", role, "| URL:", url)

            const response = await apiConnector("DELETE", url,
                { userIds: userIds },
                { Authorization: `Bearer ${token}` }
            )
            if (!response.data.success) {
                throw new Error(response.data.message)
            }
            toast.success(response.data.message)
            await dispatch(Get_Managers_User())
            role === "Organization" ? await dispatch(profile(token)) : await dispatch(Manager_Profile(token))
            return response
        } catch (error) {
            const message = error.response?.data?.message || error.message
            console.log("Error In Delete_All_User:", message)
            toast.error(message)
            return error.response
        }
    }
}

export function Delete_User_Org(userId) {
    const token = localStorage.getItem('token')
    return async (dispatch) => {
        try {
            const response = await apiConnector("DELETE", apiClient.DELETE_USER_ORG + `/${userId}`, null, {
                Authorization: `Bearer ${token}`
            })
            if (!response.data.success) {
                throw new Error(response.data.message)
            }
            toast.success(response.data.message)
            await dispatch(Get_Managers_User())
            await dispatch(profile(token))
            return response
        } catch (error) {
            const message = error.response?.data?.message || error.message
            console.log("Error In Delete_User_Org:", message)
            toast.error(message)
            return error.response
        }
    }
}
export function Update_User_Org(fromdata, userId) {
    const token = localStorage.getItem('token')
    // eslint-disable-next-line
    const role = getRole()
    return async (dispatch) => {
        try {
            const response = await apiConnector("PUT", apiClient.UPDATE_USER_ORG + `/${userId}`, fromdata, {
                Authorization: `Bearer ${token}`
            })
            if (!response.data.success) {
                throw new Error(response.data.message)
            }
            await dispatch(Get_Managers_User())
            toast.success(response.data.message)
            return response
        } catch (error) {
            const message = error.response?.data?.message || error.message
            console.log("Error In Update_User:", message)
            toast.error(message)
            return error.response
        }
    }
}

/* ============ Manager Bussinees Logic ============== */

export function Update_User(fromdata, userId) {
    const token = localStorage.getItem('token')
    // eslint-disable-next-line
    const role = getRole()
    return async (dispatch) => {
        try {
            const response = await apiConnector("PUT", apiClient.UPDATE_USER + `/${userId}`, fromdata, {
                Authorization: `Bearer ${token}`
            })
            if (!response.data.success) {
                throw new Error(response.data.message)
            }
            await dispatch(Get_Managers_User())
            toast.success(response.data.message)
            return response
        } catch (error) {
            const message = error.response?.data?.message || error.message
            console.log("Error In Update_User:", message)
            toast.error(message)
            return error.response
        }
    }
}

// ORGANIZATION ONLY
export function Get_Users() {
    const token = localStorage.getItem('token')
    return async (dispatch) => {
        try {
            const response = await apiConnector("GET", apiClient.GET_ALL_USERS, null, {
                Authorization: `Bearer ${token}`
            })
            if (!response.data.success) {
                throw new Error(response.data.message)
            }
            dispatch(setusers(response.data.data))
            toast.success(response.data.message)
        } catch (error) {
            console.log("Error In Get_Users:", error.message)
            toast.error(error.message)
        }
    }
}

// SET PASSWORD
export function Set_Password(userId, newPassword) {
    const token = localStorage.getItem('token')
    return async (dispatch) => {
        try {
            const url = apiClient.FORGOT_PASSWORD + `/${userId}`
            const response = await apiConnector("POST", url, { newPassword: newPassword }, {
                Authorization: `Bearer ${token}`
            })
            if (!response.data.success) {
                throw new Error(response.data.message)
            }
            toast.success(response.data.message || "Password updated successfully")
            return response
        } catch (error) {
            const message = error.response?.data?.message || error.message
            console.log("Error In Set_Password:", message)
            toast.error(message)
            return error.response
        }
    }
}
